module.exports = __webpack_public_path__ + "static/media/02-prototipacao.8e73ccf2.png";